const topicsData = [
  { label: '蜜桃校园', count: '128部', hot: true },
  { label: '恋爱甜宠', count: '96部', hot: true },
  { label: '奇幻冒险', count: '84部', hot: true },
  { label: '新番热映', count: '32部', hot: true },
  { label: '经典重温', count: '156部', hot: false },
  { label: '后宫日常', count: '47部', hot: false },
  { label: '百合蜜桃', count: '63部', hot: true },
  { label: '治愈温情', count: '71部', hot: false },
  { label: '热血战斗', count: '55部', hot: false },
  { label: '悬疑推理', count: '38部', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            十大热门蜜桃动漫在线标签，快速定位你喜欢的羞羞动漫在线类型
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <div
              key={i}
              className="group inline-flex items-center gap-2 px-5 py-3 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}